import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MenubarModule } from 'primeng/menubar';
import { TopNavbarComponent } from './out-of-application/top-navbar/top-navbar.component';

@NgModule({
    declarations: [TopNavbarComponent],
    imports: [CommonModule, MenubarModule],
    exports: [TopNavbarComponent]
})
export class SharedModule { }